import { TSiteType } from 'types/site.types';

export enum EFilterType {
  OWNERSHIP = 'OWNERSHIP',
  SITE_TYPE = 'SITE_TYPE',
  PARTNERS = 'PARTNERS',
  RAW_MATERIALS = 'RAW_MATERIALS',
}

export type TFilterType = `${EFilterType}`;

export enum EEntityOwnership {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
  UNASSIGNED = 'UNASSIGNED',
  PARTNER = 'PARTNER',
}

export type TEntityOwnership = `${EEntityOwnership}`;

export type TOwnershipFilterValue = {
  option?: TEntityOwnership | null;
  /**
   * Will be provided if the filter value is partner
   */
  ownedById?: string | null;
} | null;

export type TSiteTypeFilterValue = TSiteType[] | null;

export type TPartnersFilterValue = string[] | null;
export type TRawMaterialsFilterValue = string[] | null;

export type FilterValueType<Type extends TFilterType> = Type extends EFilterType.OWNERSHIP
  ? TOwnershipFilterValue
  : Type extends EFilterType.SITE_TYPE
  ? TSiteTypeFilterValue
  : Type extends EFilterType.PARTNERS
  ? TPartnersFilterValue
  : Type extends EFilterType.RAW_MATERIALS
  ? TRawMaterialsFilterValue
  : never;

export type TFilter<Type extends EFilterType = EFilterType> = {
  type: Type;
  value?: FilterValueType<Type>;
};

export type TFilterEvent =
  | {
      type: EFilterType.OWNERSHIP;
      value?: FilterValueType<EFilterType.OWNERSHIP>;
    }
  | {
      type: EFilterType.SITE_TYPE;
      value?: FilterValueType<EFilterType.SITE_TYPE>;
    }
  | {
      type: EFilterType.PARTNERS;
      value?: FilterValueType<EFilterType.PARTNERS>;
    }
  | {
      type: EFilterType.RAW_MATERIALS;
      value?: FilterValueType<EFilterType.RAW_MATERIALS>;
    };

export interface IFilterComponentProps<FilterType extends TFilterType> {
  value?: FilterValueType<FilterType> | null;
  onChange: (value?: FilterValueType<FilterType>) => void;
}
